import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import DistributorsList from '@/components/Distributors/Index'
import DistributorPage from '@/components/Distributors/SingleDistributor'
import Statistics from '@/components/Statistics/Index'
import Codes from '@/components/Codes/Index'
import SkuPage from '@/components/Sku/Index'
import CodesListPage from '@/components/Codes/List'
import CountriesPage from '@/components/Countries/Index'
import store from '../store'

Vue.use(Router)

function loginFilter (to, from, next) {
  if (!store.getters.isAuthenticated) {
    next()
    return
  }
  next('/distributors')
}

function filter (to, from, next) {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  next('/login')
}

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: DistributorsList,
      beforeEnter: filter
    },
    {
      path: '/distributors',
      name: 'Distributors',
      component: DistributorsList,
      beforeEnter: filter
    },
    { path: '/distributors/:id',
      name: 'DistributorPage',
      component: DistributorPage,
      beforeEnter: filter
    },
    { path: '/codes/:id/list',
      name: 'CodesListPage',
      component: CodesListPage,
      beforeEnter: filter
    },
    {
      path: '/sku',
      name: 'Sku',
      component: SkuPage,
      beforeEnter: filter
    },
    {
      path: '/codes',
      name: 'Codes',
      component: Codes,
      beforeEnter: filter
    },
    {
      path: '/statistics',
      name: 'Statistics',
      component: Statistics,
      beforeEnter: filter
    },
    {
      path: '/countries',
      name: 'Countries',
      component: CountriesPage,
      beforeEnter: filter
    },
    {
      path: '/countries/:search',
      name: 'Countries',
      component: CountriesPage,
      beforeEnter: filter
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      beforeEnter: loginFilter
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js